import { cn } from "@/utils/cn";
import { cva } from "class-variance-authority";

const cardVariants = cva("col-span-full grid content-start items-start", {
    variants: {
        variant: {
            default: "bg-white shadow-sm ring ring-gray-200",
        },
        size: {
            default: "gap-4 rounded-2xl p-3 md:p-4",
            sm: "",
            lg: "rounded-3xl p-6 md:p-8",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});

export const Card = ({ variant, size, className, children, ...props }) => {
    return (
        <div
            className={cn(
                cardVariants({
                    variant,
                    size,
                    className,
                }),
            )}
            {...props}
        >
            {children}
        </div>
    );
};
